import { error, json } from "@sveltejs/kit";
import { promises } from "fs";
import path from "path";
import { exec } from "child_process";
import { promisify } from "util";
const execAsync = promisify(exec);
const POST = async ({ request }) => {
  try {
    const { authContent } = await request.json();
    if (!authContent) {
      throw error(400, "Auth content is required");
    }
    let authData;
    try {
      authData = JSON.parse(authContent);
    } catch (err) {
      throw error(400, "Invalid JSON format in auth.json");
    }
    console.log("[Codex Auth] Received auth data with keys:", Object.keys(authData));
    if (typeof authData !== "object" || authData === null || Array.isArray(authData)) {
      throw error(400, "Invalid auth.json - must be a JSON object");
    }
    const hasTokenFields = Object.keys(authData).some(
      (key) => key.includes("token") || key.includes("access") || key.includes("refresh") || key.includes("expires")
    );
    if (!hasTokenFields) {
      const receivedKeys = Object.keys(authData).join(", ");
      throw error(400, `Invalid auth.json - doesn't appear to be an authentication file. Received keys: ${receivedKeys}`);
    }
    const projectRoot = path.resolve(process.cwd());
    const scriptPath = path.join(projectRoot, "scripts", "codex-auth.json");
    const setupScriptPath = path.join(projectRoot, "scripts", "codex-setup-auth.sh");
    const scriptsDir = path.dirname(scriptPath);
    await promises.mkdir(scriptsDir, { recursive: true });
    await promises.writeFile(scriptPath, authContent, "utf-8");
    console.log("[Codex Auth] auth.json written to:", scriptPath);
    try {
      await promises.access(setupScriptPath, promises.constants.X_OK);
    } catch (err) {
      try {
        await promises.chmod(setupScriptPath, "755");
        console.log("[Codex Auth] Made setup script executable");
      } catch (chmodErr) {
        console.error("[Codex Auth] Failed to make script executable:", chmodErr);
        throw error(500, "Setup script is not executable");
      }
    }
    console.log("[Codex Auth] Running setup script:", setupScriptPath);
    try {
      const { stdout, stderr } = await execAsync(setupScriptPath, {
        cwd: projectRoot,
        timeout: 3e4
        // 30 second timeout
      });
      console.log("[Codex Auth] Setup script stdout:", stdout);
      if (stderr) {
        console.log("[Codex Auth] Setup script stderr:", stderr);
      }
      if (stdout.includes("✓") || stdout.includes("Setup Complete") || stdout.includes("successfully")) {
        return json({
          success: true,
          message: "Codex authentication set up successfully! You can now use Codex CLI in Terminal panels.",
          output: stdout
        });
      } else {
        return json({
          success: true,
          message: "Codex authentication file uploaded. Check terminal for any warnings.",
          output: stdout,
          warnings: stderr || void 0
        });
      }
    } catch (execErr) {
      console.error("[Codex Auth] Setup script failed:", execErr);
      return json({
        success: true,
        message: "Auth file uploaded but automated setup encountered issues. You can run the script manually: ./scripts/codex-setup-auth.sh",
        error: execErr.message,
        output: execErr.stdout,
        stderr: execErr.stderr
      }, { status: 207 });
    }
  } catch (err) {
    if (err instanceof Response) throw err;
    console.error("[Codex Auth] Error setting up Codex authentication:", err);
    throw error(500, err.message || "Failed to setup Codex authentication");
  }
};
export {
  POST
};
